import { useCallback, useEffect, useState } from "react";
import BinaryContentApiRepository from "repositories/api/BinaryContentApiRepository";

export interface IncidentReportData {
    fileName?: string;
    content?: string;
    [key: string]: any; 
}

export interface UseFetchIncidentReportResult {
    data: IncidentReportData;
    isLoading: boolean;
}

export function useFetchIncidentReport(binaryContentId: number, reportType: string): UseFetchIncidentReportResult {
    const [data, setData] = useState<IncidentReportData>({});
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchBinaryContent = useCallback(async () => {
        try {
            var requestPromise = reportType === "pilot" ? BinaryContentApiRepository.getIncidentPilotReportById(binaryContentId) : BinaryContentApiRepository.getIncidentFinalReportById(binaryContentId)
            const response = await requestPromise as Response;
            if (response.ok) {
                const result = await response.json();
                setData(result);
            } else {
                console.error(
                    `Failed to fetch incident ${reportType} report for binaryContentId:${binaryContentId}. Response:`,
                    response,
                );
            }
            setIsLoading(false);
        } catch (error) {
            console.error(`Failed to fetch incident ${reportType} report for binaryContentId:${binaryContentId}:`, error);
            setIsLoading(false);
        }
    }, [binaryContentId]);

    useEffect(() => {
        setIsLoading(true);
        fetchBinaryContent();
    }, [fetchBinaryContent]);

    return { data, isLoading };
}